import builder from '../builder';
import BedDouble from '../../streamline-icons/light/bed-double.svg';

export default builder('IconBedDoubleLight', BedDouble);
